const DIGITIZE_TYPES_LIST_DATA = {
  titleData: {
    textList: [
      {
        id: 1,
        text: '',
        textMob: '',
        secondText: 'All Types of Analog Video Tapes',
        secondTextMob: 'All Types of',
        isTextReverse: false,
        isTextReverseMob: false,
        isTextColumn: false,
        isTextColumnMob: false,
        isLeft: true,
        isLeftMob: true,
        isRight: false,
        isRightMob: false,
        color: '#fff',
        colorMob: '#fff',
        isTextWithLine: false,
        isTextWithLineMob: false,
        isSecondTextWithLine: true,
        isSecondTextWithLineMob: true,
        firstTextLines: [],
        secondTextLines: [{
          id: 1,
          isLeftLine: false,
          isRightLine: true,
          isTopLine: false,
          isBottomLine: false,
          color: '#fff',
          isLineWithSquare: true,
          isLeftLineMob: false,
          isRightLineMob: true,
          isTopLineMob: false,
          isBottomLineMob: false,
          colorMob: '#fff',
          isLineWithSquareMob: true,
        }],
      },
      {
        id: 2,
        text: 'Converted to HD Digital.',
        textMob: 'Analog Video Tapes.',
        secondText: '',
        secondTextMob: '',
        isTextReverse: false,
        isTextReverseMob: false,
        isTextColumn: false,
        isTextColumnMob: false,
        isLeft: false,
        isLeftMob: true,
        isRight: true,
        isRightMob: false,
        color: '#fff',
        colorMob: '#fff',
        isTextWithLine: true,
        isTextWithLineMob: false,
        isSecondTextWithLine: false,
        isSecondTextWithLineMob: false,
        firstTextLines: [{
          id: 1,
          isLeftLine: true,
          isRightLine: false,
          isTopLine: false,
          isBottomLine: false,
          color: '#fff',
          isLineWithSquare: false,
          isLeftLineMob: false,
          isRightLineMob: true,
          isTopLineMob: false,
          isBottomLineMob: false,
          colorMob: '#5F8AA4',
          isLineWithSquareMob: true,
        }],
        secondTextLines: [],
      },
    ],
  },
  typesList: [
    {
      id: 1,
      title: 'VHS',
      description: 'Transfer your VHS tapes to digital format with our premium digitization service.',
      image: '',
      imageMob: '',
      link: '',
    },
    {
      id: 2,
      title: 'VHS-C',
      description: 'Convert compact VHS-C camcorder tapes to modern digital files.',
      image: '',
      imageMob: '',
      link: '',
    },
    {
      id: 3,
      title: 'Hi-8',
      description: 'Professional Hi-8 tape transfer with enhanced quality.',
      image: '',
      imageMob: '',
      link: '',
    },
    {
      id: 4,
      title: 'Mini-DV',
      description: 'Mini-DV camcorder tapes converted with premium clarity.',
      image: '',
      imageMob: '',
      link: '',
    },
    {
      id: 5,
      title: 'Betamax',
      description: 'Vintage Betamax tapes preserved in high-quality digital format.',
      image: '',
      imageMob: '',
      link: '',
    },
    {
      id: 5,
      title: 'Broadcast Types',
      description: 'Large professional cassettes such as U-matic and Betacam, used mainly in TV studios & pro productions.',
      image: '',
      imageMob: '',
      link: '',
    },
  ],
};

export default DIGITIZE_TYPES_LIST_DATA;
